const { getElements, getElement } = window.BAO.Utils

class MobileOptions extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.handleClick = this.handleClick.bind(this)

    this.els.select?.elements.forEach((select) => {
      this.listeners.add(select, 'change', this.handleSelectChange)
    })

    this.listeners.add(this.els.submit.element, 'click', this.handleClick)
  }

  handleSelectChange (event) {
    const target = event.target

    const formSelects = getElements(
      '[data-variant-selects-el="option-choice"]',
    )

    formSelects.forEach((formSelect) => {
      if (formSelect.name === target.name) {
        formSelect.value = target.value

        formSelect.dispatchEvent(new Event('change', { bubbles: true }))

        const options = formSelect.options
        Array.from(options).forEach((option) => {
          if (option.value === formSelect.value) {
            if (option.dataset.stock === 'true') {
              this.els.submit.element.setAttribute('aria-hidden', false)
              this.els['back-in-stock'].element.setAttribute(
                'aria-hidden',
                true,
              )
            } else {
              this.els.submit.element.setAttribute('aria-hidden', true)
              this.els['back-in-stock'].element.setAttribute(
                'aria-hidden',
                false,
              )
            }
          }
        })

        this.els.submit.element.innerText = `${window.variantStrings.addToCart}`
      }
    })
  }

  handleClick () {
    const outsideButton = getElement('[data-product-add-to-cart]')

    outsideButton.closest('form').setAttribute('data-mobile', '')
    outsideButton.click()
  }
}

if (!customElements.get('mobile-options')) {
  customElements.define('mobile-options', MobileOptions)
}
